export default __webpack_public_path__ + "static/media/GalaxieCopernicus-BookItalic.a0be8484.woff";